export default __webpack_public_path__ + "static/media/volume.ce5b8a3f.svg";